const LogoSmall = () => {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 8.55556C12 11.317 10.2091 13 8 13C5.79086 13 4 11.317 4 8.55556C4 5.79413 5.79086 3 8 3C10.2091 3 12 5.79413 12 8.55556Z"
        stroke="#FD505B"
        stroke-width="2"
        stroke-linecap="round"
      />
      <path
        d="M8 14L8 26"
        stroke="#FD505B"
        stroke-width="2"
        stroke-linecap="round"
      />
      <path
        d="M15.7244 4C15.268 5.09721 15 6.38487 15 7.66667C15 10.9804 16.7909 13 19 13C21.2091 13 23 10.9804 23 7.66667C23 6.38487 22.732 5.09721 22.2756 4"
        stroke="#FD505B"
        stroke-width="2"
        stroke-linecap="round"
      />
      <path
        d="M19 4L19 26"
        stroke="#FD505B"
        stroke-width="2"
        stroke-linecap="round"
      />
    </svg>
  );
};

export default LogoSmall;
